import React from 'react';
import SubjectRoundedIcon from '@material-ui/icons/DescriptionOutlined';

export function SubjectIcon() {
  return <SubjectRoundedIcon fontSize="small" />;
}
